import { useLoginMutation } from "app/services/api/authorisationApi";
import { ActionSignatureModal } from "../../actionSignature/modals/ActionSignatureModal";
import { useDisplayToast } from "ui/hooks/useDisplayToast";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "app/services/store";
import { hideAuthModal, recordSuccessfulLogin } from "app/store/slices/authModal";
import { removeAuthorisationToken } from "app/store/slices/authorisation";
import { setTokenRestored } from "app/store/slices/overlay";
import { SessionService } from "app/services/session/SessionService";

export function AuthModal() {
  const [triggerLogin] = useLoginMutation();
  const { showErrorToast } = useDisplayToast();
  const dispatch = useDispatch();

  const { isOpen } = useSelector((state: RootState) => state.authModal!);
  const token = useSelector(
    (state: RootState) => state.authorisation?.auth?.token,
  );

  const handleLogin = async (data: { email: string; password: string }) => {
    try {
      await triggerLogin(data).unwrap();

      if (token) {
        dispatch(setTokenRestored(true));
        dispatch(recordSuccessfulLogin());
        
        // Track successful re-authentication for analytics
        SessionService.trackLogin('reauth');
      }
    } catch (e) {
      showErrorToast(e, {
        title:
          e?.status === 401 ? "Invalid Credentials" : "Something went wrong",
        statusOverride: {
          401: "These login credentials are invalid. Please try again.",
        },
      });
    }
  };

  const handleCancel = () => {
    dispatch(hideAuthModal());
    dispatch(removeAuthorisationToken());
  };

  return (
    <ActionSignatureModal
      hide={!isOpen}
      title={"Login"}
      description={
        "Your session has expired. Enter your email and password in order to login to continue."
      }
      noBackgroundClose
      onCancel={handleCancel}
      onSuccess={handleLogin}
      showSecondaryButton
      primaryButtonText="Login"
      secondaryButtonText="Logout"
      blurBackground
    />
  );
}
